<!-- app-subdomain-creators/src/Components/CreatorMediaNewFolderModal.vue -->
<template>
  <TransitionRoot as="template" :show="show">
    <Dialog class="relative z-50" @close="emitClose">

      <!-- Overlay -->
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-sm transition-opacity" />
      </TransitionChild>

      <!-- Modal Container -->
      <div class="fixed top-[25%] inset-x-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-[16px] bg-zinc-100 px-5 pb-6 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
            >

              <!-- Close -->
              <button
                type="button"
                class="absolute top-3 right-3 rounded-full bg-zinc-100 text-gray-400 p-1 hover:bg-gray-200 hover:text-gray-500"
                @click="emitClose"
              >
                <XMarkIcon class="h-6 w-6" />
              </button>

              <!-- Title -->
              <DialogTitle
                as="h3"
                class="text-lg font-semibold leading-6 text-gray-900"
              >
                Create New Folder
              </DialogTitle>

              <p class="text-sm text-zinc-500 mt-1">
                Enter a name for the new folder inside this directory.
              </p>

              <!-- INPUT -->
              <div class="mt-6">
                <label class="text-sm text-zinc-600 font-medium">Folder Name</label>
                <input
                  v-model="folderName"
                  class="mt-2 w-full rounded-lg border border-zinc-300 p-2 bg-white focus:ring-[#2D8CFF] focus:border-[#2D8CFF]"
                  placeholder="My Folder"
                />
              </div>

              <!-- BUTTONS -->
              <div class="mt-8 flex justify-end gap-3">
                <button
                  @click="emitClose"
                  class="px-4 py-2 text-sm rounded-full bg-zinc-200 text-zinc-700 hover:bg-zinc-300"
                >
                  Cancel
                </button>

                <button
                  @click="emitCreate"
                  class="px-4 py-2 text-sm rounded-full bg-[#2D8CFF] text-white hover:bg-[#1b6ad1]"
                >
                  Create Folder
                </button>
              </div>

            </DialogPanel>
          </TransitionChild>
        </div>
      </div>

    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits(['close', 'create'])

const props = defineProps({
  show: Boolean
})

const folderName = ref("")

watch(
  () => props.show,
  (val) => {
    if (val) folderName.value = ""
  }
)

function emitClose() {
  emit('close')
}

function emitCreate() {
  if (!folderName.value.trim()) return
  emit('create', folderName.value.trim())
}
</script>
